import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#7540ee",
      d: "M17 10v5.434l4.515 2.708a1 1 0 0 1-1.03 1.716l-5-3A1 1 0 0 1 15 16v-6a1 1 0 0 1 2 0m-1-6a11.93 11.93 0 0 0-8.49 3.519A52 52 0 0 0 5 10.25V8a1 1 0 0 0-2 0v5a1 1 0 0 0 1 1h5a1 1 0 1 0 0-2H6.125a54 54 0 0 1 2.799-3.071 10 10 0 1 1 .207 14.344 1.003 1.003 0 0 0-1.415.04 1 1 0 0 0 .04 1.415A12 12 0 1 0 16 4"
    }, null, -1)
  ]))]))
}
export default { render: render }